const filterBrands = () => {
  const filterBtnElements = document.querySelectorAll(`.js-brands-filter-btn`);
  const filterWrapElements = document.querySelectorAll(`.js-filter-wrap`);

  function setItemActiveStatus(item, boolean) {
    item.style.display = boolean ? `` : `none`;
  }

  function checkFilterHiddenElements(type) {
    if (type !== `all`) {
      filterWrapElements.forEach((filterWrapElement) => {
        const items = Array.from(filterWrapElement.querySelectorAll(`.js-brands-filter-item`));

        setItemActiveStatus(
          filterWrapElement,
          // нахождение хотя бы одного элемента с нужным типом
          items.some((item) => JSON.parse(item.dataset.tagsToFilter).includes(type)),
        );
      });
    } else {
      filterWrapElements.forEach((filterWrapElement) => {
        setItemActiveStatus(filterWrapElement, true);
      });
    }
  }

  function onFilterBtnElementClick(evt) {
    checkFilterHiddenElements(evt.currentTarget.dataset.filterTag);
  }

  filterBtnElements.forEach((filterBtnElement) => {
    filterBtnElement.addEventListener(`click`, onFilterBtnElementClick);
  });
};

export {filterBrands};
